var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 34,
    viewBox: "0 0 8 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1C4.5 0.723858 4.27614 0.5 4 0.5C3.72386 0.5 3.5 0.723858 3.5 1H4.5ZM3.64645 33.3536C3.84171 33.5488 4.15829 33.5488 4.35355 33.3536L7.53553 30.1716C7.7308 29.9763 7.7308 29.6597 7.53553 29.4645C7.34027 29.2692 7.02369 29.2692 6.82843 29.4645L4 32.2929L1.17157 29.4645C0.976311 29.2692 0.659728 29.2692 0.464466 29.4645C0.269204 29.6597 0.269204 29.9763 0.464466 30.1716L3.64645 33.3536ZM3.5 1V33H4.5V1H3.5Z",
    fill: "#8A94AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowDown);
export default __webpack_public_path__ + "static/media/long-arrow-down.3570875e9cd4ba3bd034a634fdda6f6b.svg";
export { ForwardRef as ReactComponent };